(()=>{
  const nav=document.querySelector('[data-mobile-bottom-nav]');
  if(!nav)return;

  const isMobile=()=>window.matchMedia('(max-width: 749px)').matches;
  const menuToggle=()=>document.querySelector('[data-mobile-menu] > summary');
  const searchToggle=()=>document.querySelector('.site-header [data-mobile-search-open]');
  const headerCartCount=()=>document.querySelector('.site-header__cart-count');
  const bottomCartCount=()=>nav.querySelector('[data-mobile-bottom-cart-count]');

  function syncCartCount(){
    const source=headerCartCount();
    const target=bottomCartCount();
    if(!source||!target)return;
    const count=Math.max(0,Number.parseInt(source.textContent||'0',10)||0);
    target.textContent=String(count);
    target.hidden=count===0;
  }

  nav.addEventListener('click',(event)=>{
    if(!isMobile())return;

    const collectionsLink=event.target.closest('[data-mobile-bottom-collections]');
    if(collectionsLink){
      const toggle=menuToggle();
      if(toggle){
        event.preventDefault();
        toggle.click();
      }
      return;
    }

    const searchLink=event.target.closest('[data-mobile-bottom-search]');
    if(searchLink){
      const toggle=searchToggle();
      if(toggle){
        event.preventDefault();
        toggle.click();
      }
    }
  });

  const source=headerCartCount();
  if(source){
    syncCartCount();
    new MutationObserver(syncCartCount).observe(source,{childList:true,characterData:true,subtree:true});
  }
})();
